module.exports = __webpack_public_path__ + "static/media/DG8960-ben5.a39279be.png";